import React from 'react'
import Checkbox from '../Helper/Checkbox';

export default () => {
  return (
    <div>
        <h2>This type of dizziness is usually caused by   <strong className="text-decoration" data-tip="A condition usually caused by a viral infection that irritates the vestibular nerve, responsible for sending information to your brain about balance, causing you to feel dizzy.">Vestibular Neuritis</strong> </h2>
        <h5>Symptoms often come on suddenly and include:</h5>
        <div className="row">
            <p className="col-lg-4"><Checkbox/> sudden vertigo</p>
            <p className="col-lg-4"><Checkbox/> balance issues</p>
            <p className="col-lg-4"><Checkbox/> nausea and vomiting</p>
            <p className="col-lg-4"><Checkbox/> dizziness</p>
            <p className="col-lg-4"><Checkbox/> trouble concentrating</p>
        </div>
        
        <p>For the fastest recovery, we recommend that you contact a healthcare provider for definitive testing and appropriate treatment, as medication may be needed for best results.</p>
        <a  id="Neuritis Labyrinthitis" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
